(function () {
    angular.module('tradersyard').factory('AuthService', authServiceFactory);

    authServiceFactory.$inject = ['$rootScope'];

    function authServiceFactory($rootScope) {
        return {
            getUser,
            getUserId,
            isUserAuthenticated,
            isAdmin,
            onUserChanged,
        };

        /**
         * This callback is displayed as part of the Requester class.
         * @callback AuthService~userCallback
         * @param {null|AuthenticatedUser} user
         */

        /**
         * Watch current user
         * @param {AuthService~userCallback} cb - The callback that handles the response.
         */
        function onUserChanged(cb) {
            $rootScope.$watch('me', cb);
        }

        /**
         * Get current user or null in case of not logged in user
         * @return {null|AuthenticatedUser}
         */
        function getUser() {
            return $rootScope.me ? $rootScope.me : null;
        }

        /**
         * Get current user ID or null for not logged in user
         * @return {number|null}
         */
        function getUserId() {
            const user = getUser();
            return user ? user.id : null;
        }

        function isUserAuthenticated() {
            return typeof $rootScope.me !== 'undefined';
        }

        function isAdmin() {
            return getUser().is_admin || false;
        }
    }
})();
